const mall= {
    path: 'mall',
    component: resolve => require(['../../../../../../pages/admin/merchant/dispose/mall'], resolve),
    meta: {
      requireAuth: true
    }
  }
  
  export default mall